import { useEffect } from "react";

export default function PrivacyPage() {
  useEffect(() => {
    document.title =
      "Политика конфиденциальности и согласие на обработку персональных данных";
  }, []);

  return (
    <div className="max-w-4xl mx-auto w-full px-4 sm:px-5 lg:px-14 py-4 sm:py-5 lg:py-14">
      <div className="bg-white rounded-lg max-w-5xl p-8 sm:p-10">
        <h1 className="mx-auto max-w-2xl leading-[1.3] sm:text-center text-base sm:text-xl font-bold font-unbounded text-[#293545]">
          Политика конфиденциальности и согласие{" "}
          <br className="hidden sm:block" />
          на обработку персональных данных
        </h1>
        <article className="flex flex-col max-w-none w-full text-zinc-800 font-onest mt-6 sm:mt-8 text-sm">
          <ul className="">
            <li className="">
              <h4 className="font-medium text-base text-[#293545]">
                1. Общие положения
              </h4>
              <p className="mt-1">
                Настоящая Политика конфиденциальности и согласие на обработку
                персональных данных (далее — Политика) регулируют обработку и
                защиту персональных данных пользователей веб-сервиса{" "}
                <a
                  href="https://forms.chm12.ru"
                  className="text-zinc-700 hover:text-zinc-950 duration-300 font-medium underline"
                >
                  https://forms.chm12.ru
                </a>{" "}
                (далее — Сервис), предоставляемого Централизованной религиозной
                организацией Южное епархиальное управление Российского
                объединенного Союза христиан веры евангельской (пятидесятников)
                (далее — Организация).
                <br />
                <br />
                Заполняя формы на сайте, Пользователь подтверждает свое согласие
                с настоящей Политикой и дает разрешение на обработку своих
                персональных данных.
              </p>
            </li>
            <li className="mt-4 space-y-1">
              <h4 className="font-medium text-base text-[#293545]">
                2. Термины и определения
              </h4>
              <li className="inline-flex gap-2">
                <div className="h-1 w-1 bg-zinc-500 rounded-full flex-none mt-2"></div>
                <div>
                  <span className="font-medium text-[#293545]">2.1.</span>{" "}
                  <span className="font-medium">Персональные данные</span> —
                  любая информация, относящаяся к прямо или косвенно
                  определенному физическому лицу (субъекту персональных данных).
                </div>
              </li>
              <li className="inline-flex gap-2">
                <div className="h-1 w-1 bg-zinc-500 rounded-full flex-none mt-2"></div>
                <div>
                  <span className="font-medium text-[#293545]">2.2.</span>{" "}
                  <span className="font-medium">
                    Обработка персональных данных
                  </span>{" "}
                  — любое действие (операция) или совокупность действий,
                  совершаемых с использованием средств автоматизации или без
                  таковых, с персональными данными.
                </div>
              </li>
              <li className="inline-flex gap-2">
                <div className="h-1 w-1 bg-zinc-500 rounded-full flex-none mt-2"></div>
                <div>
                  <span className="font-medium text-[#293545]">2.3.</span>{" "}
                  <span className="font-medium">Пользователь</span> — физическое
                  лицо, использующее Сервис.
                </div>
              </li>
              <li className="inline-flex gap-2">
                <div className="h-1 w-1 bg-zinc-500 rounded-full flex-none mt-2"></div>
                <div>
                  <span className="font-medium text-[#293545]">2.4.</span>{" "}
                  <span className="font-medium">Оператор</span> — Организация,
                  осуществляющая обработку персональных данных Пользователей.
                </div>
              </li>
            </li>
            <li className="mt-4 space-y-1">
              <h4 className="font-medium text-base text-[#293545]">
                3. Цели обработки персональных данных
              </h4>
              <li className="inline-flex gap-2">
                <div className="h-1 w-1 bg-zinc-500 rounded-full flex-none mt-2"></div>
                <div>
                  <span className="font-medium text-[#293545]">3.1.</span>{" "}
                  Оператор обрабатывает персональные данные в следующих целях:
                  <ul className="">
                    <li>
                      - Предоставление Пользователю доступа к функционалу
                      Сервиса;
                    </li>
                    <li>- Обеспечение обратной связи с Пользователем;</li>
                  </ul>
                </div>
              </li>
            </li>

            <li className="mt-4 space-y-1">
              <h4 className="font-medium text-base text-[#293545]">
                4. Обрабатываемые данные
              </h4>
              <li className="inline-flex gap-2">
                <div className="h-1 w-1 bg-zinc-500 rounded-full flex-none mt-2"></div>
                <div>
                  <span className="font-medium text-[#293545]">4.1.</span> В
                  рамках использования Сервиса могут обрабатываться следующие
                  категории персональных данных:
                  <ul className="">
                    <li>- ФИО;</li>
                    <li>- Контактные данные (телефон, email);</li>
                    <li>- Данные, вводимые Пользователем в формах Сервиса;</li>
                  </ul>
                </div>
              </li>
              <li className="inline-flex gap-2">
                <div className="h-1 w-1 bg-zinc-500 rounded-full flex-none mt-2"></div>
                <div>
                  <span className="font-medium text-[#293545]">4.2.</span>{" "}
                  Пользователь несет ответственность за достоверность
                  предоставляемых данных.
                </div>
              </li>
            </li>

            <li className="mt-4 space-y-1">
              <h4 className="font-medium text-base text-[#293545]">
                5. Правовые основания обработки
              </h4>
              <li className="inline-flex gap-2">
                <div className="h-1 w-1 bg-zinc-500 rounded-full flex-none mt-2"></div>
                <div>
                  <span className="font-medium text-[#293545]">5.1.</span>{" "}
                  Обработка персональных данных осуществляется на основании:{" "}
                  <ul className="">
                    <li>
                      - Федерального закона от 27.07.2006 № 152-ФЗ «О
                      персональных данных»;
                    </li>
                    <li>
                      - Согласия Пользователя на обработку его персональных
                      данных;
                    </li>
                    <li>- Договоров, заключенных с Пользователем.</li>
                  </ul>
                </div>
              </li>
            </li>

            <li className="mt-4 space-y-1">
              <h4 className="font-medium text-base text-[#293545]">
                6. Условия обработки и передачи персональных данных
              </h4>
              <li className="inline-flex gap-2">
                <div className="h-1 w-1 bg-zinc-500 rounded-full flex-none mt-2"></div>
                <div>
                  <span className="font-medium text-[#293545]">6.1.</span>{" "}
                  Оператор принимает все необходимые меры для защиты
                  персональных данных от несанкционированного доступа,
                  изменения, раскрытия или уничтожения.
                </div>
              </li>
              <li className="inline-flex gap-2">
                <div className="h-1 w-1 bg-zinc-500 rounded-full flex-none mt-2"></div>
                <div>
                  <span className="font-medium text-[#293545]">6.2.</span>{" "}
                  Персональные данные Пользователей могут передаваться третьим
                  лицам только в случаях, предусмотренных законодательством
                  Российской Федерации.
                </div>
              </li>
            </li>

            <li className="mt-4 space-y-1">
              <h4 className="font-medium text-base text-[#293545]">
                7. Условия обработки и передачи персональных данных
              </h4>
              <li className="inline-flex gap-2">
                <div className="h-1 w-1 bg-zinc-500 rounded-full flex-none mt-2"></div>
                <div>
                  <span className="font-medium text-[#293545]">7.1.</span>{" "}
                  Персональные данные обрабатываются в течение срока,
                  необходимого для достижения целей обработки, указанных в
                  настоящей Политике.
                </div>
              </li>
              <li className="inline-flex gap-2">
                <div className="h-1 w-1 bg-zinc-500 rounded-full flex-none mt-2"></div>
                <div>
                  <span className="font-medium text-[#293545]">7.2.</span>{" "}
                  Пользователь вправе отозвать свое согласие на обработку
                  данных, направив соответствующий запрос Оператору.
                </div>
              </li>
            </li>

            <li className="mt-4 space-y-1">
              <h4 className="font-medium text-base text-[#293545]">
                8. Права пользователя
              </h4>
              <li className="inline-flex gap-2">
                <div className="h-1 w-1 bg-zinc-500 rounded-full flex-none mt-2"></div>
                <div>
                  <span className="font-medium text-[#293545]">8.1.</span>{" "}
                  Пользователь имеет право:
                  <ul className="">
                    <li>
                      - Получать информацию о своих персональных данных,
                      обрабатываемых Оператором;
                    </li>
                    <li>
                      - Требовать уточнения, блокировки или уничтожения своих
                      данных в случае их неполноты, устаревания или незаконной
                      обработки;
                    </li>
                    <li>
                      - Обжаловать действия Оператора в установленном законом
                      порядке.
                    </li>
                  </ul>
                </div>
              </li>
            </li>

            <li className="mt-4 space-y-1">
              <h4 className="font-medium text-base text-[#293545]">
                9. Контактная информация
              </h4>
              <li className="inline-flex gap-2">
                <div className="h-1 w-1 bg-zinc-500 rounded-full flex-none mt-2"></div>
                <div>
                  Для связи с Оператором по вопросам обработки персональных
                  данных обращайтесь:
                  <ul className="">
                    <li>
                      - Адрес: г. Москва, Варшавское шоссе, 129 к2с2, офис 501
                    </li>
                    <li>- Email: admin@cxm12.ru</li>
                  </ul>
                </div>
              </li>
            </li>
          </ul>
          <p></p>
        </article>
      </div>
    </div>
  );
}
